import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { EmploymentRecordStockPurchasePlan, EmploymentRecordStockPurchasePlanSubmit } from '../models/employment-record-stock-purchase-plan.model';
import { EnvironmentService } from "@app/core/services/environment.service";


const headers = new HttpHeaders({
  'Content-Type':  'application/json',
});
@Injectable({
  providedIn: 'root'
})
export class EmploymentRecordStockPurchasePlanService {

  constructor(private http: HttpClient, private envService: EnvironmentService) { }

  getStockPurchasePlans(employeeId: string, employmentRecordId: string, take?: number, skip?: number): Observable<any> {
    let params = new HttpParams();
    skip ? params = params.append('skip', skip) : null;
    take ? params = params.append('take', take) : null;

    return this.http
      .get<any>(this.envService.env.apiUrl + `Employee/${employeeId}/EmploymentRecord/${employmentRecordId}/StockPurchasePlan`, {
        headers: headers,
        observe: 'response',
        params: params
      })
      .pipe(
        catchError(err => throwError(err)),
        map(res => {
          let data = {
            stockPurchasePlans: res.body,
            pagination: JSON.parse(res.headers.get('X-Pagination'))
          }

          return data;
        })
      );
  }

  getStockPurchasePlan(employeeId: string, employmentRecordId: string, stockPurchasePlanId: string): Observable<EmploymentRecordStockPurchasePlan> {
    return this.http.get<any>(this.envService.env.apiUrl + `Employee/${employeeId}/EmploymentRecord/${employmentRecordId}/StockPurchasePlan/${stockPurchasePlanId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  postStockPurchasePlan(employeeId: string, employmentRecordId: string, stockPurchasePlan: EmploymentRecordStockPurchasePlanSubmit): Observable<EmploymentRecordStockPurchasePlan> {
    return this.http.post<any>(this.envService.env.apiUrl + `Employee/${employeeId}/EmploymentRecord/${employmentRecordId}/StockPurchasePlan`, stockPurchasePlan, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  deleteStockPurchasePlan(employeeId: string, employmentRecordId: string, stockPurchasePlanId: string): Observable<any> {
    return this.http.delete<any>(this.envService.env.apiUrl + `Employee/${employeeId}/EmploymentRecord/${employmentRecordId}/StockPurchasePlan/${stockPurchasePlanId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
}

